import React from 'react'
import PropTypes from 'prop-types'
import styles from '@bt-react/styles'
import classnames from 'classnames'
import { ButtonProps } from './types'

export default class Button extends React.Component<ButtonProps> {

  onClick = () => {

    if (!this.props.disabled && this.props.onClick) {

      this.props.onClick()

    }

  }

  static propTypes = {
    text: PropTypes.string.isRequired
  }

  render () {

    const switchButtonClasses = classnames(
      styles['btn'],
      this.props.className,
      this.props.additionalClass,
      styles['btn-switch'],
      {
        [styles['btn-switch-on']]: this.props.active
      }
    )

    return (
      <button
        disabled={this.props.disabled}
        className={switchButtonClasses}
        onClick={this.onClick}
        data-bdd={`${this.props.active ? 'switch-on' : 'switch-off'}${this.props.disabled ? '-disabled' : '-enabled'}`}
      >
        <span className={styles['btn-switch-text']}>{this.props.text}</span>
        <span className={styles['btn-switch-status']}/>
      </button>
    )

  }

}
